import { Component, OnDestroy, OnInit } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {GpsTracksConfigComponent, GpsTracksSettings} from '../gps-tracks-config/gps-tracks-config.component';
import {SettingsService} from '../../../../configuration/settings.service';
import { ConfigurationService } from '../../../../configuration/configuration.service';
import { TrackStyles } from '../../../../configuration/model/TrackStyles';
import { Subscription } from 'rxjs';
import { LayerTypeFilter } from '../../../../configuration/model/LayerTypeFilter';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { LineDashArrayViewComponent } from '../../line-type-item/line-dash-array-view.component';
import { LineStyle } from '../../../models/styling';

@Component({
  selector: 'app-gps-tracks-legend',
  templateUrl: './gps-tracks-legend.component.html',
  styleUrls: ['./gps-tracks-legend.component.scss'],
  imports: [MatIconButton, MatTooltip, MatIcon, LineDashArrayViewComponent],
})
export class GpsTracksLegendComponent implements OnInit, OnDestroy {
  defaultTrackStyles: TrackStyles;
  defaultStylesSubscription: Subscription;
  defaultLegendSettings: LayerTypeFilter;

  userTrackStyles: TrackStyles;
  userStylesSubscription: Subscription;
  userLegendSettings: LayerTypeFilter;

  constructor(
    public dialog: MatDialog,
    private settingsService: SettingsService,
    private configurationService: ConfigurationService,
  ) {}

  ngOnInit() {
    this.defaultStylesSubscription = this.configurationService.trackStyles$.subscribe(trackStyles => {
      this.defaultTrackStyles = trackStyles;
      this.defaultLegendSettings = LayerTypeFilter.gpsTracksLayerTypeFilter(trackStyles);
    });
    this.userStylesSubscription = this.configurationService.userTrackStyles$.subscribe(trackStyles => {
      this.userTrackStyles = trackStyles;
      this.userLegendSettings = LayerTypeFilter.gpsTracksLayerTypeFilter(trackStyles);
    });
  }

  ngOnDestroy() {
    this.userStylesSubscription?.unsubscribe();
  }

  openConfiguration() {
    const defaultConfigCopy = JSON.parse(JSON.stringify(this.defaultLegendSettings));
    const active = this.userLegendSettings.measurementUnits.find(i => i.number === 'Active');
    const recent = this.userLegendSettings.measurementUnits.find(i => i.number === 'Recent');
    const data = {
      showRecent: this.settingsService.getBooleanValue(SettingsService.PLOW_TRACK_SHOW_RECENT),
      timeLimit: +this.settingsService.getStringValue(SettingsService.PLOW_TRACK_TIME_FILTER),
      defaultLegendSettings: defaultConfigCopy,
      styleActive: new LineStyle(
        active?.color,
        4,
        1,
        active?.dashArray,
      ),
      styleRecent: new LineStyle(
        recent?.color,
        4,
        1,
        recent?.dashArray,
      )
    } as GpsTracksSettings;

    const dialogRef = this.dialog.open(GpsTracksConfigComponent, {
      maxWidth: '80vw',
      maxHeight: '85vh',
      width: '520px',
      height: '400px',
      data: Object.assign({}, data),
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined && result) {
        const settings = result as GpsTracksSettings;
        if (settings.showRecent !== data.showRecent) {
          this.settingsService.setBooleanValue(SettingsService.PLOW_TRACK_SHOW_RECENT, settings.showRecent);
        }
        if (settings.timeLimit !== data.timeLimit) {
          this.settingsService.setStringValue(SettingsService.PLOW_TRACK_TIME_FILTER, String(settings.timeLimit));
        }

        const active = settings.styleActive;
        const defaultActive = this.defaultLegendSettings.measurementUnits.find(i => i.number === 'Active');
        if (active && defaultActive) {
          if (active.color === defaultActive.color && active.lineType === defaultActive.dashArray) {
            this.settingsService.setStringValue(SettingsService.GPS_TRACK_ACTIVE_TRACK_STYLE, null);
          } else {
            this.userTrackStyles.liveMapPlowLive.color = active.color;
            this.userTrackStyles.liveMapPlowLive.dasharray = active.lineType;
            this.settingsService.setStringValue(
              SettingsService.GPS_TRACK_ACTIVE_TRACK_STYLE,
              JSON.stringify(this.userTrackStyles.liveMapPlowLive)
            );
          }
        }
        const recent = settings.styleRecent;
        const defaultRecent = this.defaultLegendSettings.measurementUnits.find(i => i.number === 'Recent');
        if (recent && defaultRecent) {
          if (recent.color === defaultRecent.color && recent.lineType === defaultRecent.dashArray) {
            this.settingsService.setStringValue(SettingsService.GPS_TRACK_RECENT_TRACK_STYLE, null);
          } else {
            this.userTrackStyles.liveMapPlowInactive.color = recent.color;
            this.userTrackStyles.liveMapPlowInactive.dasharray = recent.lineType;
            this.settingsService.setStringValue(
              SettingsService.GPS_TRACK_RECENT_TRACK_STYLE,
              JSON.stringify(this.userTrackStyles.liveMapPlowInactive)
            );
          }
        }

        this.configurationService.refreshUserTrackStyles();
      }
    });
  }
}
